import React from "react";

import {
  StyledCard,
  StyledModalProps,
  StyledCloseButton,
  StyledContent,
  StyledLayout,
} from "./styled";

export type ModalProps = {
  closeHandler: () => void;
  onDrop?: () => void;
} & StyledModalProps;

export const Modal: React.FC<ModalProps> = ({
  children,
  closeHandler,
  onDrop,
  ...rest
}) => {
  return (
    <StyledLayout
      onClick={() => {
        closeHandler();
      }}
      onDrop={onDrop}
    >
      <StyledCard
        {...rest}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <StyledCloseButton onClick={closeHandler} />
        <StyledContent {...rest}>{children}</StyledContent>
      </StyledCard>
    </StyledLayout>
  );
};
